import { render, staticRenderFns } from "./ActiveSubstanceForm.vue?vue&type=template&id=653e3ba8&"
import script from "./ActiveSubstanceForm.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports